import axios, { AxiosInstance } from 'axios';
import { getApiUrl, loadAppConfig } from 'config/appConfig';

const api: AxiosInstance = axios.create({
  baseURL: getApiUrl(),
  headers: { 'Content-Type': 'application/json' },
});

loadAppConfig().then(() => {
  api.defaults.baseURL = getApiUrl();
});

export default api;
